// src/mocks/handlers/search.handlers.js
import * as data from '../data/search.demo';

// Normalize text for accent-insensitive, case-insensitive matching
function normalize(str) {
    return String(str ?? '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
}

export const searchProducts = async (config) => {
    // Parse query params from the full URL string
    let search = '';
    let includeStockedOnly = false;
    let includeFavoritesOnly = false;
    let categoryName = '';

    try {
        // axios.get(fullUrlWithParams) puts everything in config.url
        // Ensure we have an absolute URL for the URL constructor
        const raw = config.url ?? '';
        const urlObj = new URL(raw.startsWith('http') ? raw : `http://x${raw.startsWith('/') ? '' : '/'}${raw}`);
        search               = urlObj.searchParams.get('search')               ?? '';
        includeStockedOnly   = urlObj.searchParams.get('includeStockedOnly')   === 'true';
        includeFavoritesOnly = urlObj.searchParams.get('includeFavoritesOnly') === 'true';
        categoryName         = urlObj.searchParams.get('categoryName')         ?? '';
    } catch (e) {
        console.warn('[DEMO search] URL parse failed:', e.message);
    }

    const term = normalize(search.trim());

    let results = data.searchResults;

    // Text filter — matches description, brand, code, or EAN
    if (term) {
        results = results.filter((p) =>
            normalize(p.ProductDescription).includes(term) ||
            normalize(p.BrandName).includes(term) ||
            normalize(p.ProductCode).includes(term) ||
            normalize(p.EAN).includes(term)
        );
    }

    // Category filter
    if (categoryName && categoryName !== 'All categories') {
        const cat = normalize(categoryName);
        results = results.filter((p) => normalize(p.CategoryName).includes(cat));
    }

    // Stock filter
    if (includeStockedOnly) {
        results = results.filter((p) => (p.IndividualUnitCount ?? 0) > 0);
    }

    // Favorites filter
    if (includeFavoritesOnly) {
        results = results.filter((p) => p.IsFavorite === 1);
    }

    return results;
};

export const setFavorite = async () => ({ success: true });
